import {BaseModel} from '.'

/**
 * User model
 */
class User extends BaseModel {
  // Default attributes that define the "empty" state.
  defaults () {
    return {
      id: null,
      email: '',
      emailVerified: false,
      firstname: '',
      lastname: '',
      done: false
    }
  }

  // Route configuration
  routes () {
    return {
      fetch: '/users/{id}',
      save: '/users',
      delete: '/users/{id}'
    }
  }
}

export {User}



//////////////////
// WEBPACK FOOTER
// ./src/models/User.js
// module id = 889
// module chunks = 1